var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3616",
    "data-name": "Group 3616",
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 59,
    viewBox: "0 0 61 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 30.5,
    cy: 29.5,
    rx: 30.5,
    ry: 29.5,
    fill: "#ffeaea"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "shield-check_3_",
    "data-name": "shield-check (3)",
    d: "M20.118,2.338,13.272.056a1.093,1.093,0,0,0-.691,0L5.736,2.338A5.456,5.456,0,0,0,2,7.521v5.591C2,21.376,12.053,25.94,12.483,26.131a1.093,1.093,0,0,0,.887,0c.431-.19,10.483-4.754,10.483-13.018V7.521a5.456,5.456,0,0,0-3.736-5.183Zm-2.036,8.279-4.668,4.668a2.047,2.047,0,0,1-1.459.6h-.036a2.046,2.046,0,0,1-1.47-.656L7.93,12.612A1.093,1.093,0,1,1,9.5,11.1l2.452,2.557,4.576-4.589a1.093,1.093,0,1,1,1.545,1.545Z",
    transform: "translate(18.073 16.888)",
    fill: "#ff004e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafe);
export default __webpack_public_path__ + "static/media/safe.0d0a95e7e3591979462d280c7b1a7956.svg";
export { ForwardRef as ReactComponent };